// Add data types to window.navigator ambiently for implicit use in the entire project. See https://www.typescriptlang.org/docs/handbook/triple-slash-directives.html#-reference-types- for more info.
/// <reference types="user-agent-data-types" />

// Fix iOS scrolling


export const iOSfix = (modalContainer: HTMLDivElement) => {
    const modalContent =
        document.querySelector<HTMLDivElement>('.ncuim-wrapper')!;
    const iOS =
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.userAgentData?.platform === 'macOS' &&
            navigator.maxTouchPoints > 1);

    if (iOS && !document.body.classList.contains('iosFix')) {
        const offset = document.body.scrollTop;
        document.body.style.top = `${offset * -1}px`;
        document.body.classList.add('iosFix');
        _lockBodyScroll(modalContainer);
        _addBottomPaddingForTallPopups(modalContent, modalContainer);
    }
};
export const undoIOSfix = () => {
    if (!document.body.classList.contains('iosFix')) return;
    const offset = parseInt(document.body.style.top, 10);
    document.body.classList.remove('iosFix');
    document.body.style.top = '';
    document.body.scrollTop = offset * -1;
};

// 하단에 확인 버튼이 있는 경우 사파리에서 브라우저 입력창이 뜨는 이슈
const _addBottomPaddingForTallPopups = (
    modalContent: HTMLDivElement,
    modalContainer: HTMLDivElement
) => {
    const ua = navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);
    const iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    if (iOSSafari) {
        const bottomPanelHeight = 44;
        if (
            modalContent.scrollHeight >
            window.innerHeight - bottomPanelHeight
        ) {
            modalContainer.style.paddingBottom = `${bottomPanelHeight}px`;
        }
    }
};

const _lockBodyScroll = (modalContainer: HTMLDivElement) => {
    let preventTouchMove: boolean;
    modalContainer.ontouchstart = (event: TouchEvent) => {
        preventTouchMove = _shouldPreventTouchMove(event, modalContainer);
    };
    modalContainer.ontouchmove = (event: TouchEvent) => {
        if (!preventTouchMove) return;
        event.preventDefault();
        event.stopPropagation();
    };
};

const _shouldPreventTouchMove = (
    event: TouchEvent,
    modalContainer: HTMLDivElement
) => {
    const htmlContainer = document.body.querySelector<HTMLDivElement>(
        '.ncuim-html-container'
    )!;
    const target = event.target;

    if (isStylus(event) || isZoom(event)) {
        return false;
    }
    if (target === modalContainer) {
        return true;
    }
    if (
        !isScrollable(modalContainer) &&
        target instanceof HTMLElement &&
        target.tagName !== 'INPUT' &&
        target.tagName !== 'TEXTAREA' &&
        !(isScrollable(htmlContainer) && htmlContainer.contains(target))
    ) {
        return true;
    }
    return false;
};

// 터치 방식이 펜일 경우
const isStylus = (event: TouchEvent) => {
    return (
        event.touches &&
        event.touches.length &&
        (event.touches[0] as TouchInit).touchType === 'stylus'
    );
};

const isScrollable = (elem: HTMLElement) =>
    !!(elem.scrollHeight > elem.clientHeight);

// 축소 및 줌 금지
const isZoom = (event: TouchEvent) => {
    return event.touches && event.touches.length > 1;
};
